import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}`;

export const fetchSingleSoftwareMaintenanceHistory = async (
  softwareId: string | number,
  softwareMaintenanceId: number | null,
) => {
  const res = await api.get(
    `${apiEndPoint}/software/${softwareId}/history/${softwareMaintenanceId}`,
  );

  return res;
};

export const createSingleSoftwareMaintenanceHistory = async (
  id: string | number,
  data: any,
) => {
  try {
    const resData = await api.post(
      `${apiEndPoint}/add/software/history/${id}`,
      {
        ...data,
      },
    );
    return {
      resData,
      status: "SUCCESS",
    };
  } catch (error) {
    return {
      status: "FAILED",
    };
  }
};
